import React from 'react';
import { IIcons } from '../interfaces/icons';

export function Close({fillColor}: IIcons) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      fill="none"
      viewBox="0 0 12 12"
    >
      <path
        stroke={fillColor || '#071C3E'}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m.75.75 10.5 10.5M11.25.75.75 11.25"
      />
    </svg>
  );
}
